// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__UrmU0","errors":"Errors_errors__25q1H"};